// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: v6GVasCmjcoJpKZhA57bGQ
// Component: aut6KnfbkQmpXP
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Navbar from "../../Navbar"; // plasmic-import: -P5pSOuII0lcb0/component
import Button from "../../Button"; // plasmic-import: NxycUbS85IVXb2/component

import { useScreenVariants as useScreenVariantshQ7Ab2TDfxBfTk } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: hQ7AB2tDFXBfTk/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_mechz.module.css"; // plasmic-import: v6GVasCmjcoJpKZhA57bGQ/projectcss
import sty from "./PlasmicPlay.module.css"; // plasmic-import: aut6KnfbkQmpXP/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: kmDjyMAgVxdWnp/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: 3m4uVCB_20TDjx/icon
import _227601RightArrowIconsvgIcon from "./icons/PlasmicIcon___227601RightArrowIconsvg"; // plasmic-import: 28ccL-rkNGYuT4/icon
import westworldpngAU4PfpXaJ5C from "./images/westworldpng.png"; // plasmic-import: aU4PFP_xaJ-5c-/picture
import redDeadLogopngPgZeWenK85AS61 from "./images/redDeadLogopng.png"; // plasmic-import: PgZeWenK85aS61/picture
import algoLogopng6EyEFjsYp6OR from "./images/algoLogopng.png"; // plasmic-import: 6ey-EFjs-YP6oR/picture
import encodeLogopng7ZFVyimedNqLuU from "./images/encodeLogopng.png"; // plasmic-import: 7zFVyimedNqLuU/picture
import suelpngLEji5TgoWy5IwE from "./images/suelpng.png"; // plasmic-import: LEji5TGOWy5iwE/picture
import image7FlN99ZYSevQePk from "./images/image7.png"; // plasmic-import: FlN99zYSevQEPk/picture
import tradingpngCzYg5Poath6Isk from "./images/tradingpng.png"; // plasmic-import: czYG5poath6Isk/picture
import image481AQlsDnuyhwX8 from "./images/image4.png"; // plasmic-import: 81AQlsDnuyhwX8/picture
import unityPlaceholderpngRHAzfr1KctwZi from "./images/unityPlaceholderpng.png"; // plasmic-import: r-hAZFR1kctwZI/picture
import noFuelCell22FGrqmCyh from "./images/noFuelCell2.png"; // plasmic-import: 2fGRQMCyh/picture
import fuelCellAnim2Gif8Lfy8RZcu from "./images/fuelCellAnim2Gif.gif"; // plasmic-import: 8lfy8rZCU/picture
import mechz1186X80Png48Ym0AsJt from "./images/mechz1186X80Png.png"; // plasmic-import: 48YM0ASJt/picture
import icons8TwittersvgW5ZvFLoqAuH8Zu from "./images/icons8Twittersvg.svg"; // plasmic-import: w5ZvFLoqAuH8zu/picture
import icons8Facebooksvg2X2E0IGuunMaBs from "./images/icons8Facebooksvg.svg"; // plasmic-import: 2X2e0iGuunMaBS/picture
import icons8YoutubesvgSYrq6VrcDciGse from "./images/icons8Youtubesvg.svg"; // plasmic-import: sYRQ6vrcDCIGse/picture
import icons8Vimeosvg9Yh6CNw0Rwm923 from "./images/icons8Vimeosvg.svg"; // plasmic-import: 9Yh6cNw0rwm923/picture

export type PlasmicPlay__VariantMembers = {};

export type PlasmicPlay__VariantsArgs = {};
type VariantPropType = keyof PlasmicPlay__VariantsArgs;
export const PlasmicPlay__VariantProps = new Array<VariantPropType>();

export type PlasmicPlay__ArgsType = {
  unity?: React.ReactNode;
  ticketImage?: React.ReactNode;
};

type ArgPropType = keyof PlasmicPlay__ArgsType;
export const PlasmicPlay__ArgProps = new Array<ArgPropType>(
  "unity",
  "ticketImage"
);

export type PlasmicPlay__OverridesType = {
  root?: p.Flex<"div">;
  navbar?: p.Flex<typeof Navbar>;
  section2?: p.Flex<"section">;
  subHeading?: p.Flex<"h2">;
  logoContainer?: p.Flex<"div">;
  section3?: p.Flex<"section">;
  twoSideBox?: p.Flex<"div">;
  subHeading2?: p.Flex<"h2">;
  peraContent?: p.Flex<"p">;
  unorderList?: p.Flex<"ul">;
  listIteam?: p.Flex<"li">;
  listIteam3?: p.Flex<"li">;
  listIteam4?: p.Flex<"li">;
  listIteam5?: p.Flex<"li">;
  listIteam6?: p.Flex<"li">;
  listIteam7?: p.Flex<"li">;
  bannerImage2?: p.Flex<"div">;
  imageMarketing2?: p.Flex<typeof p.PlasmicImg>;
  section4?: p.Flex<"section">;
  testimonialText?: p.Flex<"h2">;
  position?: p.Flex<"p">;
  section5?: p.Flex<"section">;
  twoSidedContent?: p.Flex<"div">;
  subHeading3?: p.Flex<"h2">;
  line2?: p.Flex<"div">;
  ol?: p.Flex<"ol">;
  section6?: p.Flex<"section">;
  twoSideBox2?: p.Flex<"div">;
  subHeading4?: p.Flex<"h2">;
  peraContent2?: p.Flex<"p">;
  unorderList2?: p.Flex<"ul">;
  listIteam2?: p.Flex<"li">;
  listIteam9?: p.Flex<"li">;
  listIteam10?: p.Flex<"li">;
  listIteam11?: p.Flex<"li">;
  listIteam12?: p.Flex<"li">;
  listIteam13?: p.Flex<"li">;
  bannerImage3?: p.Flex<"div">;
  imageMarketing3?: p.Flex<typeof p.PlasmicImg>;
  section7?: p.Flex<"section">;
  subHeading5?: p.Flex<"h2">;
  line3?: p.Flex<"div">;
  blockChapterContent?: p.Flex<"div">;
  blockChapterContent4?: p.Flex<"div">;
  blockChapterContent2?: p.Flex<"div">;
  blockChapterContent3?: p.Flex<"div">;
  section8?: p.Flex<"section">;
  avtarContent?: p.Flex<"div">;
  avatarImage?: p.Flex<"div">;
  section9?: p.Flex<"section">;
  svg?: p.Flex<"svg">;
  section1?: p.Flex<"section">;
  container?: p.Flex<"div">;
  useTicket?: p.Flex<typeof Button>;
  flexBox?: p.Flex<"div">;
  bannerImage?: p.Flex<"div">;
  contentBlock?: p.Flex<"div">;
  mainHeading?: p.Flex<"h1">;
  peraBanner?: p.Flex<"p">;
  footer?: p.Flex<"footer">;
  footerLogo?: p.Flex<"div">;
  logo2?: p.Flex<typeof p.PlasmicImg>;
  footerLink?: p.Flex<"a">;
  footerLink4?: p.Flex<"a">;
  footerLink5?: p.Flex<"a">;
  copyRight?: p.Flex<"p">;
  socialIcons?: p.Flex<"div">;
  twitter?: p.Flex<typeof p.PlasmicImg>;
  facebook?: p.Flex<typeof p.PlasmicImg>;
  youtube?: p.Flex<typeof p.PlasmicImg>;
  vimeo?: p.Flex<typeof p.PlasmicImg>;
};

export interface DefaultPlayProps {
  unity?: React.ReactNode;
  ticketImage?: React.ReactNode;
  className?: string;
}

function PlasmicPlay__RenderFunc(props: {
  variants: PlasmicPlay__VariantsArgs;
  args: PlasmicPlay__ArgsType;
  overrides: PlasmicPlay__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = args;

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantshQ7Ab2TDfxBfTk()
  });

  return (
    <React.Fragment>
      {}

      {}

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <Navbar
            data-plasmic-name={"navbar"}
            data-plasmic-override={overrides.navbar}
            className={classNames("__wab_instance", sty.navbar)}
          />

          {true ? (
            <p.Stack
              as={"section"}
              data-plasmic-name={"section2"}
              data-plasmic-override={overrides.section2}
              hasGap={true}
              className={classNames(projectcss.all, sty.section2)}
            >
              <h2
                data-plasmic-name={"subHeading"}
                data-plasmic-override={overrides.subHeading}
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.subHeading
                )}
              >
                {"Inspired by:"}
              </h2>

              <p.Stack
                as={"div"}
                data-plasmic-name={"logoContainer"}
                data-plasmic-override={overrides.logoContainer}
                hasGap={true}
                className={classNames(projectcss.all, sty.logoContainer)}
              >
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__o1Ha)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("auto" as const)
                      : ("auto" as const)
                  }
                  displayMaxHeight={"none" as const}
                  displayMaxWidth={"100%" as const}
                  displayMinHeight={"0" as const}
                  displayMinWidth={"0" as const}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("100px" as const)
                      : ("180px" as const)
                  }
                  loading={"lazy" as const}
                  src={{
                    src: westworldpngAU4PfpXaJ5C,
                    fullWidth: 175,
                    fullHeight: 122,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__dIyF)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("auto" as const)
                      : ("85px" as const)
                  }
                  displayMaxHeight={"none" as const}
                  displayMaxWidth={"100%" as const}
                  displayMinHeight={"0" as const}
                  displayMinWidth={"0" as const}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("100px" as const)
                      : ("180px" as const)
                  }
                  loading={"lazy" as const}
                  src={{
                    src: redDeadLogopngPgZeWenK85AS61,
                    fullWidth: 175,
                    fullHeight: 83,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img___2O5)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("auto" as const)
                      : ("66px" as const)
                  }
                  displayMaxHeight={"none" as const}
                  displayMaxWidth={"100%" as const}
                  displayMinHeight={"0" as const}
                  displayMinWidth={"0" as const}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("120px" as const)
                      : ("157px" as const)
                  }
                  loading={"lazy" as const}
                  src={{
                    src: algoLogopng6EyEFjsYp6OR,
                    fullWidth: 175,
                    fullHeight: 83,
                    aspectRatio: undefined
                  }}
                />

                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__jgrVp)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("auto" as const)
                      : ("80.999px" as const)
                  }
                  displayMaxHeight={"none" as const}
                  displayMaxWidth={"100%" as const}
                  displayMinHeight={"0" as const}
                  displayMinWidth={"0" as const}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? ("100px" as const)
                      : ("164.999px" as const)
                  }
                  loading={"lazy" as const}
                  src={{
                    src: encodeLogopng7ZFVyimedNqLuU,
                    fullWidth: 175,
                    fullHeight: 83,
                    aspectRatio: undefined
                  }}
                />
              </p.Stack>
            </p.Stack>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section3"}
              data-plasmic-override={overrides.section3}
              className={classNames(projectcss.all, sty.section3)}
            >
              <div
                data-plasmic-name={"twoSideBox"}
                data-plasmic-override={overrides.twoSideBox}
                className={classNames(projectcss.all, sty.twoSideBox)}
              >
                {(
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? true
                    : true
                ) ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__n93WH)}
                  >
                    {(
                      hasVariant(globalVariants, "screen", "mobileOnly")
                        ? true
                        : true
                    ) ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__buMRa
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__vYf4V
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__xqsYd
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox__jnRaU
                              )}
                            >
                              <h2
                                data-plasmic-name={"subHeading2"}
                                data-plasmic-override={overrides.subHeading2}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.h2,
                                  sty.subHeading2
                                )}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__pvDw6
                                  )}
                                >
                                  {"So Much to do in\nAlgo Ranchero"}
                                </div>

                                <p
                                  data-plasmic-name={"peraContent"}
                                  data-plasmic-override={overrides.peraContent}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.p,
                                    projectcss.__wab_text,
                                    sty.peraContent
                                  )}
                                >
                                  {"Be the hero of your own western:"}
                                </p>

                                <ul
                                  data-plasmic-name={"unorderList"}
                                  data-plasmic-override={overrides.unorderList}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.ul,
                                    sty.unorderList
                                  )}
                                >
                                  <li
                                    data-plasmic-name={"listIteam"}
                                    data-plasmic-override={overrides.listIteam}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam
                                    )}
                                  >
                                    {"Collect Character Skins"}
                                  </li>

                                  <li
                                    data-plasmic-name={"listIteam3"}
                                    data-plasmic-override={overrides.listIteam3}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam3
                                    )}
                                  >
                                    {"Collect Weapons"}
                                  </li>

                                  <li
                                    data-plasmic-name={"listIteam4"}
                                    data-plasmic-override={overrides.listIteam4}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam4
                                    )}
                                  >
                                    {"Duel for Prizes\n"}
                                  </li>

                                  <li
                                    data-plasmic-name={"listIteam5"}
                                    data-plasmic-override={overrides.listIteam5}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam5
                                    )}
                                  >
                                    {"Collect and Ride Horses"}
                                  </li>

                                  <li
                                    data-plasmic-name={"listIteam6"}
                                    data-plasmic-override={overrides.listIteam6}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam6
                                    )}
                                  >
                                    {"Discover new lands\n"}
                                  </li>

                                  <li
                                    data-plasmic-name={"listIteam7"}
                                    data-plasmic-override={overrides.listIteam7}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.listIteam7
                                    )}
                                  >
                                    {"Meet new characters"}
                                  </li>
                                </ul>
                              </h2>
                            </div>

                            <Button
                              className={classNames(
                                "__wab_instance",
                                sty.button__ujX
                              )}
                              color={"red" as const}
                              shape={"rounded" as const}
                              showEndIcon={true}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__xI7Uo
                                )}
                              >
                                {"Start Playing"}
                              </div>
                            </Button>
                          </div>

                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__w8Aga
                            )}
                          >
                            <div
                              data-plasmic-name={"bannerImage2"}
                              data-plasmic-override={overrides.bannerImage2}
                              className={classNames(
                                projectcss.all,
                                sty.bannerImage2
                              )}
                            >
                              <p.PlasmicImg
                                data-plasmic-name={"imageMarketing2"}
                                data-plasmic-override={
                                  overrides.imageMarketing2
                                }
                                alt={""}
                                className={classNames(sty.imageMarketing2)}
                                displayHeight={
                                  hasVariant(
                                    globalVariants,
                                    "screen",
                                    "mobileOnly"
                                  )
                                    ? ("auto" as const)
                                    : ("100%" as const)
                                }
                                displayMaxHeight={"none" as const}
                                displayMaxWidth={"100%" as const}
                                displayMinHeight={"0" as const}
                                displayMinWidth={"0" as const}
                                displayWidth={
                                  hasVariant(
                                    globalVariants,
                                    "screen",
                                    "mobileOnly"
                                  )
                                    ? ("400px" as const)
                                    : ("100%" as const)
                                }
                                loading={"lazy" as const}
                                src={{
                                  src: suelpngLEji5TgoWy5IwE,
                                  fullWidth: 611,
                                  fullHeight: 458,
                                  aspectRatio: undefined
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section4"}
              data-plasmic-override={overrides.section4}
              className={classNames(projectcss.all, sty.section4)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__h1S0)}>
                <div className={classNames(projectcss.all, sty.columns__zEhE)}>
                  <div
                    className={classNames(projectcss.all, sty.column__fX6Ss)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__v9QWz)}
                      displayHeight={"256px" as const}
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={"256px" as const}
                      loading={"lazy" as const}
                      src={{
                        src: image7FlN99ZYSevQePk,
                        fullWidth: 1112,
                        fullHeight: 794,
                        aspectRatio: undefined
                      }}
                    />
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column__qtnpR)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__wtjl)}
                    >
                      <h2
                        data-plasmic-name={"testimonialText"}
                        data-plasmic-override={overrides.testimonialText}
                        className={classNames(
                          projectcss.all,
                          projectcss.h2,
                          projectcss.__wab_text,
                          sty.testimonialText
                        )}
                      >
                        {
                          "“This course is a must-take for anyone in digital marketing. Worth every penny.”"
                        }
                      </h2>

                      <p
                        data-plasmic-name={"position"}
                        data-plasmic-override={overrides.position}
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.position
                        )}
                      >
                        {"Jane Doe, Sr. Marketing Manager at Company"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section5"}
              data-plasmic-override={overrides.section5}
              className={classNames(projectcss.all, sty.section5)}
            >
              <div
                data-plasmic-name={"twoSidedContent"}
                data-plasmic-override={overrides.twoSidedContent}
                className={classNames(projectcss.all, sty.twoSidedContent)}
              >
                <h2
                  data-plasmic-name={"subHeading3"}
                  data-plasmic-override={overrides.subHeading3}
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.subHeading3
                  )}
                >
                  {"RoadMap"}
                </h2>

                <div
                  data-plasmic-name={"line2"}
                  data-plasmic-override={overrides.line2}
                  className={classNames(projectcss.all, sty.line2)}
                />

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.columns__xug8A)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column__yokCi)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__dkKct
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <ol
                            data-plasmic-name={"ol"}
                            data-plasmic-override={overrides.ol}
                            className={classNames(
                              projectcss.all,
                              projectcss.ol,
                              sty.ol
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__n2IIg
                              )}
                            >
                              {"Ticket To Ride "}
                            </li>
                          </ol>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__rd8Fe
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column__xbRGv)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2___06CCc
                      )}
                    >
                      {"2. Unlock Characters"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__jHPem
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>

                  <div className={classNames(projectcss.all, sty.column__cygm)}>
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__c7AYk
                      )}
                    >
                      {"3. Unlock Worlds "}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__luTYs
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>

                  <div className={classNames(projectcss.all, sty.column__rSRc)}>
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__e57No
                      )}
                    >
                      {"4. Unlock Missions"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__toMRn
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column__lM9RJ)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__ev7C
                      )}
                    >
                      {"5. Unlock Missions"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__tvy4N
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column___16N8A)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__gNfaS
                      )}
                    >
                      {"6. Unlock Duels"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__eJhkr
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>
                </p.Stack>
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section6"}
              data-plasmic-override={overrides.section6}
              className={classNames(projectcss.all, sty.section6)}
            >
              <div
                data-plasmic-name={"twoSideBox2"}
                data-plasmic-override={overrides.twoSideBox2}
                className={classNames(projectcss.all, sty.twoSideBox2)}
              >
                <div className={classNames(projectcss.all, sty.columns__e7Ri6)}>
                  <div
                    className={classNames(projectcss.all, sty.column__z6NYo)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__rlKz)}
                    >
                      <h2
                        data-plasmic-name={"subHeading4"}
                        data-plasmic-override={overrides.subHeading4}
                        className={classNames(
                          projectcss.all,
                          projectcss.h2,
                          sty.subHeading4
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__kqrBx
                          )}
                        >
                          {"Collect Everything"}
                        </div>

                        <p
                          data-plasmic-name={"peraContent2"}
                          data-plasmic-override={overrides.peraContent2}
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.peraContent2
                          )}
                        >
                          {
                            "You can Win, Buy and Sell almost Everything in Algo Ranchero"
                          }
                        </p>

                        <ul
                          data-plasmic-name={"unorderList2"}
                          data-plasmic-override={overrides.unorderList2}
                          className={classNames(
                            projectcss.all,
                            projectcss.ul,
                            sty.unorderList2
                          )}
                        >
                          <li
                            data-plasmic-name={"listIteam2"}
                            data-plasmic-override={overrides.listIteam2}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam2
                            )}
                          >
                            {"Characters and Skins"}
                          </li>

                          <li
                            data-plasmic-name={"listIteam9"}
                            data-plasmic-override={overrides.listIteam9}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam9
                            )}
                          >
                            {"Weapons\n"}
                          </li>

                          <li
                            data-plasmic-name={"listIteam10"}
                            data-plasmic-override={overrides.listIteam10}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam10
                            )}
                          >
                            {"Horses\n"}
                          </li>

                          <li
                            data-plasmic-name={"listIteam11"}
                            data-plasmic-override={overrides.listIteam11}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam11
                            )}
                          >
                            {"Decorations\n"}
                          </li>

                          <li
                            data-plasmic-name={"listIteam12"}
                            data-plasmic-override={overrides.listIteam12}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam12
                            )}
                          >
                            {"Consumable Items"}
                          </li>

                          <li
                            data-plasmic-name={"listIteam13"}
                            data-plasmic-override={overrides.listIteam13}
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.listIteam13
                            )}
                          >
                            {"Land"}
                          </li>
                        </ul>
                      </h2>
                    </div>

                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__wjSZr
                      )}
                      color={"red" as const}
                      shape={"rounded" as const}
                      showEndIcon={true}
                    >
                      {"Start Playing"}
                    </Button>
                  </div>

                  <div className={classNames(projectcss.all, sty.column__gHRr)}>
                    <div
                      data-plasmic-name={"bannerImage3"}
                      data-plasmic-override={overrides.bannerImage3}
                      className={classNames(projectcss.all, sty.bannerImage3)}
                    >
                      <p.PlasmicImg
                        data-plasmic-name={"imageMarketing3"}
                        data-plasmic-override={overrides.imageMarketing3}
                        alt={""}
                        className={classNames(sty.imageMarketing3)}
                        displayHeight={
                          hasVariant(globalVariants, "screen", "mobileOnly")
                            ? ("auto" as const)
                            : ("100%" as const)
                        }
                        displayMaxHeight={"none" as const}
                        displayMaxWidth={"100%" as const}
                        displayMinHeight={"0" as const}
                        displayMinWidth={"0" as const}
                        displayWidth={
                          hasVariant(globalVariants, "screen", "mobileOnly")
                            ? ("400px" as const)
                            : ("100%" as const)
                        }
                        loading={"lazy" as const}
                        src={{
                          src: tradingpngCzYg5Poath6Isk,
                          fullWidth: 611,
                          fullHeight: 458,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section7"}
              data-plasmic-override={overrides.section7}
              className={classNames(projectcss.all, sty.section7)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__eXdkf)}>
                <h2
                  data-plasmic-name={"subHeading5"}
                  data-plasmic-override={overrides.subHeading5}
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.subHeading5
                  )}
                >
                  {"Who should take this course?"}
                </h2>

                <div
                  data-plasmic-name={"line3"}
                  data-plasmic-override={overrides.line3}
                  className={classNames(projectcss.all, sty.line3)}
                />
              </div>

              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns___7MYmg)}
              >
                <div className={classNames(projectcss.all, sty.column__s0Kvw)}>
                  <div
                    data-plasmic-name={"blockChapterContent"}
                    data-plasmic-override={overrides.blockChapterContent}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__cKmDk
                      )}
                    >
                      {"Marketers"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__hvcIp
                      )}
                    >
                      {"Learn how all of the marketing pieces fit together"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__e5Ar
                      )}
                    >
                      {"Master digital marketing for any business"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__wlvIg
                      )}
                    >
                      {"Get access to marketing gurus and their tips"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__g2RWf
                      )}
                    >
                      {"Prepare killer presentations and collateral"}
                    </li>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__d7F1)}>
                  <div
                    data-plasmic-name={"blockChapterContent4"}
                    data-plasmic-override={overrides.blockChapterContent4}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent4
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___1TqXm
                      )}
                    >
                      {"Product managers"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__oktnG
                      )}
                    >
                      {"Understand the context of your product work"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li___6JjN
                      )}
                    >
                      {"Learn how to segment your audience properly"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__xpAjz
                      )}
                    >
                      {"Implement brand voice and style in your work"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__z2Ty2
                      )}
                    >
                      {"Connect top of funnel activities with your flow"}
                    </li>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__s3OMt)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__kT30P
                    )}
                  >
                    {"Designers"}
                  </div>

                  <li
                    className={classNames(
                      projectcss.all,
                      projectcss.li,
                      sty.li__h1Uon
                    )}
                  >
                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__efUo
                      )}
                    >
                      {"Learn how your design can inspire action"}
                    </li>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___8DJjf
                      )}
                    >
                      {"Gain big picture insights that affect design"}
                    </div>

                    <div
                      data-plasmic-name={"blockChapterContent2"}
                      data-plasmic-override={overrides.blockChapterContent2}
                      className={classNames(
                        projectcss.all,
                        sty.blockChapterContent2
                      )}
                    >
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__iEzQ
                        )}
                      >
                        {"Make advertisements that convert"}
                      </li>

                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__jr55T
                        )}
                      >
                        {"Create digital assets for the right audience"}
                      </li>
                    </div>
                  </li>
                </div>

                <div className={classNames(projectcss.all, sty.column__aUqaC)}>
                  <div
                    data-plasmic-name={"blockChapterContent3"}
                    data-plasmic-override={overrides.blockChapterContent3}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent3
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zcJsz
                      )}
                    >
                      {"Business owners"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__yqco3
                      )}
                    >
                      {"Kickstart your marketing plan and efforts"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li___4Cadn
                      )}
                    >
                      {"Upgrade your brand, website and social media"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__owHHk
                      )}
                    >
                      {"Prepare effective collateral for your business"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__lJUvp
                      )}
                    >
                      {"Start advertising your company online"}
                    </li>
                  </div>
                </div>
              </p.Stack>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section8"}
              data-plasmic-override={overrides.section8}
              className={classNames(projectcss.all, sty.section8)}
            >
              <div className={classNames(projectcss.all, sty.columns__o2INc)}>
                <div className={classNames(projectcss.all, sty.column___4Umgm)}>
                  <div
                    data-plasmic-name={"avtarContent"}
                    data-plasmic-override={overrides.avtarContent}
                    className={classNames(projectcss.all, sty.avtarContent)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2___4L7NH
                      )}
                    >
                      {"About the instructor"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__tx8Cy
                      )}
                    >
                      {"Jane Doe, Title"}
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__q0IHn
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__t60DY
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__a4XJ
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__aCxlt)}>
                  <div
                    data-plasmic-name={"avatarImage"}
                    data-plasmic-override={overrides.avatarImage}
                    className={classNames(projectcss.all, sty.avatarImage)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img___4UQfM)}
                      displayHeight={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("100%" as const)
                          : ("auto" as const)
                      }
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("400px" as const)
                          : ("auto" as const)
                      }
                      loading={"lazy" as const}
                      src={{
                        src: image481AQlsDnuyhwX8,
                        fullWidth: 930,
                        fullHeight: 1162,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section9"}
              data-plasmic-override={overrides.section9}
              className={classNames(projectcss.all, sty.section9)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__wHvrU)}>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__pAd6X
                  )}
                >
                  {"Access the course today"}
                </h2>
              </div>

              <Button
                className={classNames("__wab_instance", sty.button__ktXSw)}
                color={"white" as const}
                endIcon={
                  <_227601RightArrowIconsvgIcon
                    data-plasmic-name={"svg"}
                    data-plasmic-override={overrides.svg}
                    className={classNames(projectcss.all, sty.svg)}
                    role={"img"}
                  />
                }
                shape={"rounded" as const}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__uUmLb
                  )}
                >
                  {"Access the course"}
                </div>
              </Button>
            </section>
          ) : null}

          <section
            data-plasmic-name={"section1"}
            data-plasmic-override={overrides.section1}
            className={classNames(projectcss.all, sty.section1)}
          >
            <div
              data-plasmic-name={"container"}
              data-plasmic-override={overrides.container}
              className={classNames(projectcss.all, sty.container)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__vPp9)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__ggTSo)}>
                  {p.renderPlasmicSlot({
                    defaultContents: null,
                    value: args.unity
                  })}
                </div>

                {true ? (
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__klbWk)}
                    displayHeight={"auto" as const}
                    displayMaxHeight={"none" as const}
                    displayMaxWidth={"100%" as const}
                    displayMinHeight={"0" as const}
                    displayMinWidth={"0" as const}
                    displayWidth={"auto" as const}
                    loading={"lazy" as const}
                    src={{
                      src: unityPlaceholderpngRHAzfr1KctwZi,
                      fullWidth: 800,
                      fullHeight: 534,
                      aspectRatio: undefined
                    }}
                  />
                ) : null}

                {true ? (
                  <Button
                    data-plasmic-name={"useTicket"}
                    data-plasmic-override={overrides.useTicket}
                    className={classNames("__wab_instance", sty.useTicket)}
                  >
                    {"Use Ticket"}
                  </Button>
                ) : null}

                {p.renderPlasmicSlot({
                  defaultContents: (
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__tiDjR)}
                      displayHeight={"auto" as const}
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={"auto" as const}
                      link={
                        "https://objkt.com/asset/KT1K58hY9q4ckHnb1KGXB2XgbM49EXZTWPBy/0" as const
                      }
                      loading={"lazy" as const}
                      src={{
                        src: noFuelCell22FGrqmCyh,
                        fullWidth: 300,
                        fullHeight: 566,
                        aspectRatio: undefined
                      }}
                    />
                  ),

                  value: args.ticketImage
                })}
              </p.Stack>

              {true ? (
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"flexBox"}
                  data-plasmic-override={overrides.flexBox}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.flexBox)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column__skL05)}
                  >
                    <div
                      data-plasmic-name={"bannerImage"}
                      data-plasmic-override={overrides.bannerImage}
                      className={classNames(projectcss.all, sty.bannerImage)}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img___8MQvO)}
                        displayHeight={"auto" as const}
                        displayMaxHeight={"none" as const}
                        displayMaxWidth={"100%" as const}
                        displayMinHeight={"0" as const}
                        displayMinWidth={"0" as const}
                        displayWidth={"400px" as const}
                        loading={"lazy" as const}
                        src={{
                          src: fuelCellAnim2Gif8Lfy8RZcu,
                          fullWidth: 156,
                          fullHeight: 240,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column__vzi9A)}
                  >
                    <div
                      data-plasmic-name={"contentBlock"}
                      data-plasmic-override={overrides.contentBlock}
                      className={classNames(projectcss.all, sty.contentBlock)}
                    >
                      <h1
                        data-plasmic-name={"mainHeading"}
                        data-plasmic-override={overrides.mainHeading}
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.mainHeading
                        )}
                      >
                        {
                          "Your Fuel Cell Grants Access to The Pre-Release World of Mechz"
                        }
                      </h1>

                      <p
                        data-plasmic-name={"peraBanner"}
                        data-plasmic-override={overrides.peraBanner}
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          sty.peraBanner
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__rzWs4
                          )}
                        >
                          {
                            "If you own an Experimental Fuel Cell, you have unlimited access to the Mechz world as it's being built.\n\nOne Fuel Cell is all you need. It doesn't get burned or destroyed when you access the game-world.\n\nYou'll be able to see the world evolve and grow as you have access to the untested locations and enemy units that will become the final game-world.\n\nEnjoy this exclusive access to the behind-the-scenes peek into how this game is coming together. "
                          }
                        </div>
                      </p>

                      {true ? (
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__eSNzB
                          )}
                        >
                          <Button
                            className={classNames(
                              "__wab_instance",
                              sty.button__mOx6O
                            )}
                            color={"softBlue" as const}
                            link={
                              "https://objkt.com/asset/KT1K58hY9q4ckHnb1KGXB2XgbM49EXZTWPBy/0" as const
                            }
                            shape={"rounded" as const}
                            showEndIcon={true}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__xl1Hv
                              )}
                            >
                              {"Get A Fuel Cell"}
                            </div>
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </p.Stack>
              ) : null}
            </div>
          </section>

          <footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames(projectcss.all, sty.footer)}
          >
            <div className={classNames(projectcss.all, sty.columns___2RtIb)}>
              <div className={classNames(projectcss.all, sty.column__qux7W)}>
                <div
                  data-plasmic-name={"footerLogo"}
                  data-plasmic-override={overrides.footerLogo}
                  className={classNames(projectcss.all, sty.footerLogo)}
                >
                  <p.PlasmicImg
                    data-plasmic-name={"logo2"}
                    data-plasmic-override={overrides.logo2}
                    alt={""}
                    className={classNames(sty.logo2)}
                    displayHeight={"auto" as const}
                    displayMaxHeight={"none" as const}
                    displayMaxWidth={"100%" as const}
                    displayMinHeight={"0" as const}
                    displayMinWidth={"0" as const}
                    displayWidth={"300px" as const}
                    loading={"lazy" as const}
                    src={{
                      src: mechz1186X80Png48Ym0AsJt,
                      fullWidth: 186,
                      fullHeight: 80,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              </div>

              <div className={classNames(projectcss.all, sty.column___0GDq1)}>
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__tyZz
                  )}
                >
                  {"Company"}
                </h3>

                <a
                  data-plasmic-name={"footerLink"}
                  data-plasmic-override={overrides.footerLink}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink
                  )}
                  href={"/" as const}
                >
                  {"Story"}
                </a>
              </div>

              <div className={classNames(projectcss.all, sty.column__coKz3)}>
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__mgbbt
                  )}
                >
                  {"Legal"}
                </h3>

                <a
                  data-plasmic-name={"footerLink4"}
                  data-plasmic-override={overrides.footerLink4}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink4
                  )}
                  href={"/" as const}
                >
                  {"Terms & Conditions"}
                </a>

                <a
                  data-plasmic-name={"footerLink5"}
                  data-plasmic-override={overrides.footerLink5}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink5
                  )}
                  href={"/" as const}
                >
                  {"Privacy Policy"}
                </a>
              </div>
            </div>
          </footer>

          <div className={classNames(projectcss.all, sty.freeBox__nxFqw)}>
            <div className={classNames(projectcss.all, sty.columns__b4EJn)}>
              <div className={classNames(projectcss.all, sty.column__ygnOd)}>
                <p
                  data-plasmic-name={"copyRight"}
                  data-plasmic-override={overrides.copyRight}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.copyRight
                  )}
                >
                  {"© Blockchain Alchemy. All rights reserved. "}
                </p>
              </div>

              {true ? (
                <div className={classNames(projectcss.all, sty.column__oaT6L)}>
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"socialIcons"}
                    data-plasmic-override={overrides.socialIcons}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.socialIcons)}
                  >
                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__nzHno
                        )}
                        href={"https://twitter.com/" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"twitter"}
                          data-plasmic-override={overrides.twitter}
                          alt={""}
                          className={classNames(sty.twitter)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8TwittersvgW5ZvFLoqAuH8Zu,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__ngWn5
                        )}
                        href={"#" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"facebook"}
                          data-plasmic-override={overrides.facebook}
                          alt={""}
                          className={classNames(sty.facebook)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8Facebooksvg2X2E0IGuunMaBs,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__ryJy5
                        )}
                        href={"#" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"youtube"}
                          data-plasmic-override={overrides.youtube}
                          alt={""}
                          className={classNames(sty.youtube)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8YoutubesvgSYrq6VrcDciGse,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link___9Yn9W
                        )}
                        href={"#" as const}
                      >
                        {true ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__ntJw
                            )}
                          >
                            <p.PlasmicImg
                              data-plasmic-name={"vimeo"}
                              data-plasmic-override={overrides.vimeo}
                              alt={""}
                              className={classNames(sty.vimeo)}
                              displayHeight={"auto" as const}
                              displayMaxHeight={"none" as const}
                              displayMaxWidth={"100%" as const}
                              displayMinHeight={"0" as const}
                              displayMinWidth={"0" as const}
                              displayWidth={"30px" as const}
                              loading={"lazy" as const}
                              src={{
                                src: icons8Vimeosvg9Yh6CNw0Rwm923,
                                fullWidth: 150,
                                fullHeight: 150,
                                aspectRatio: 1
                              }}
                            />
                          </div>
                        ) : null}
                      </a>
                    ) : null}
                  </p.Stack>
                </div>
              ) : null}
            </div>
          </div>
        </p.Stack>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "navbar",
    "section2",
    "subHeading",
    "logoContainer",
    "section3",
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "bannerImage2",
    "imageMarketing2",
    "section4",
    "testimonialText",
    "position",
    "section5",
    "twoSidedContent",
    "subHeading3",
    "line2",
    "ol",
    "section6",
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "bannerImage3",
    "imageMarketing3",
    "section7",
    "subHeading5",
    "line3",
    "blockChapterContent",
    "blockChapterContent4",
    "blockChapterContent2",
    "blockChapterContent3",
    "section8",
    "avtarContent",
    "avatarImage",
    "section9",
    "svg",
    "section1",
    "container",
    "useTicket",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner",
    "footer",
    "footerLogo",
    "logo2",
    "footerLink",
    "footerLink4",
    "footerLink5",
    "copyRight",
    "socialIcons",
    "twitter",
    "facebook",
    "youtube",
    "vimeo"
  ],
  navbar: ["navbar"],
  section2: ["section2", "subHeading", "logoContainer"],
  subHeading: ["subHeading"],
  logoContainer: ["logoContainer"],
  section3: [
    "section3",
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "bannerImage2",
    "imageMarketing2"
  ],
  twoSideBox: [
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "bannerImage2",
    "imageMarketing2"
  ],
  subHeading2: [
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7"
  ],
  peraContent: ["peraContent"],
  unorderList: [
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7"
  ],
  listIteam: ["listIteam"],
  listIteam3: ["listIteam3"],
  listIteam4: ["listIteam4"],
  listIteam5: ["listIteam5"],
  listIteam6: ["listIteam6"],
  listIteam7: ["listIteam7"],
  bannerImage2: ["bannerImage2", "imageMarketing2"],
  imageMarketing2: ["imageMarketing2"],
  section4: ["section4", "testimonialText", "position"],
  testimonialText: ["testimonialText"],
  position: ["position"],
  section5: ["section5", "twoSidedContent", "subHeading3", "line2", "ol"],
  twoSidedContent: ["twoSidedContent", "subHeading3", "line2", "ol"],
  subHeading3: ["subHeading3"],
  line2: ["line2"],
  ol: ["ol"],
  section6: [
    "section6",
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "bannerImage3",
    "imageMarketing3"
  ],
  twoSideBox2: [
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "bannerImage3",
    "imageMarketing3"
  ],
  subHeading4: [
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13"
  ],
  peraContent2: ["peraContent2"],
  unorderList2: [
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13"
  ],
  listIteam2: ["listIteam2"],
  listIteam9: ["listIteam9"],
  listIteam10: ["listIteam10"],
  listIteam11: ["listIteam11"],
  listIteam12: ["listIteam12"],
  listIteam13: ["listIteam13"],
  bannerImage3: ["bannerImage3", "imageMarketing3"],
  imageMarketing3: ["imageMarketing3"],
  section7: [
    "section7",
    "subHeading5",
    "line3",
    "blockChapterContent",
    "blockChapterContent4",
    "blockChapterContent2",
    "blockChapterContent3"
  ],
  subHeading5: ["subHeading5"],
  line3: ["line3"],
  blockChapterContent: ["blockChapterContent"],
  blockChapterContent4: ["blockChapterContent4"],
  blockChapterContent2: ["blockChapterContent2"],
  blockChapterContent3: ["blockChapterContent3"],
  section8: ["section8", "avtarContent", "avatarImage"],
  avtarContent: ["avtarContent"],
  avatarImage: ["avatarImage"],
  section9: ["section9", "svg"],
  svg: ["svg"],
  section1: [
    "section1",
    "container",
    "useTicket",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner"
  ],
  container: [
    "container",
    "useTicket",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner"
  ],
  useTicket: ["useTicket"],
  flexBox: [
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner"
  ],
  bannerImage: ["bannerImage"],
  contentBlock: ["contentBlock", "mainHeading", "peraBanner"],
  mainHeading: ["mainHeading"],
  peraBanner: ["peraBanner"],
  footer: [
    "footer",
    "footerLogo",
    "logo2",
    "footerLink",
    "footerLink4",
    "footerLink5"
  ],
  footerLogo: ["footerLogo", "logo2"],
  logo2: ["logo2"],
  footerLink: ["footerLink"],
  footerLink4: ["footerLink4"],
  footerLink5: ["footerLink5"],
  copyRight: ["copyRight"],
  socialIcons: ["socialIcons", "twitter", "facebook", "youtube", "vimeo"],
  twitter: ["twitter"],
  facebook: ["facebook"],
  youtube: ["youtube"],
  vimeo: ["vimeo"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  navbar: typeof Navbar;
  section2: "section";
  subHeading: "h2";
  logoContainer: "div";
  section3: "section";
  twoSideBox: "div";
  subHeading2: "h2";
  peraContent: "p";
  unorderList: "ul";
  listIteam: "li";
  listIteam3: "li";
  listIteam4: "li";
  listIteam5: "li";
  listIteam6: "li";
  listIteam7: "li";
  bannerImage2: "div";
  imageMarketing2: typeof p.PlasmicImg;
  section4: "section";
  testimonialText: "h2";
  position: "p";
  section5: "section";
  twoSidedContent: "div";
  subHeading3: "h2";
  line2: "div";
  ol: "ol";
  section6: "section";
  twoSideBox2: "div";
  subHeading4: "h2";
  peraContent2: "p";
  unorderList2: "ul";
  listIteam2: "li";
  listIteam9: "li";
  listIteam10: "li";
  listIteam11: "li";
  listIteam12: "li";
  listIteam13: "li";
  bannerImage3: "div";
  imageMarketing3: typeof p.PlasmicImg;
  section7: "section";
  subHeading5: "h2";
  line3: "div";
  blockChapterContent: "div";
  blockChapterContent4: "div";
  blockChapterContent2: "div";
  blockChapterContent3: "div";
  section8: "section";
  avtarContent: "div";
  avatarImage: "div";
  section9: "section";
  svg: "svg";
  section1: "section";
  container: "div";
  useTicket: typeof Button;
  flexBox: "div";
  bannerImage: "div";
  contentBlock: "div";
  mainHeading: "h1";
  peraBanner: "p";
  footer: "footer";
  footerLogo: "div";
  logo2: typeof p.PlasmicImg;
  footerLink: "a";
  footerLink4: "a";
  footerLink5: "a";
  copyRight: "p";
  socialIcons: "div";
  twitter: typeof p.PlasmicImg;
  facebook: typeof p.PlasmicImg;
  youtube: typeof p.PlasmicImg;
  vimeo: typeof p.PlasmicImg;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPlay__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPlay__VariantsArgs;
    args?: PlasmicPlay__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPlay__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicPlay__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicPlay__ArgProps,
          internalVariantPropNames: PlasmicPlay__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicPlay__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPlay";
  } else {
    func.displayName = `PlasmicPlay.${nodeName}`;
  }
  return func;
}

export const PlasmicPlay = Object.assign(
  // Top-level PlasmicPlay renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navbar: makeNodeComponent("navbar"),
    section2: makeNodeComponent("section2"),
    subHeading: makeNodeComponent("subHeading"),
    logoContainer: makeNodeComponent("logoContainer"),
    section3: makeNodeComponent("section3"),
    twoSideBox: makeNodeComponent("twoSideBox"),
    subHeading2: makeNodeComponent("subHeading2"),
    peraContent: makeNodeComponent("peraContent"),
    unorderList: makeNodeComponent("unorderList"),
    listIteam: makeNodeComponent("listIteam"),
    listIteam3: makeNodeComponent("listIteam3"),
    listIteam4: makeNodeComponent("listIteam4"),
    listIteam5: makeNodeComponent("listIteam5"),
    listIteam6: makeNodeComponent("listIteam6"),
    listIteam7: makeNodeComponent("listIteam7"),
    bannerImage2: makeNodeComponent("bannerImage2"),
    imageMarketing2: makeNodeComponent("imageMarketing2"),
    section4: makeNodeComponent("section4"),
    testimonialText: makeNodeComponent("testimonialText"),
    position: makeNodeComponent("position"),
    section5: makeNodeComponent("section5"),
    twoSidedContent: makeNodeComponent("twoSidedContent"),
    subHeading3: makeNodeComponent("subHeading3"),
    line2: makeNodeComponent("line2"),
    ol: makeNodeComponent("ol"),
    section6: makeNodeComponent("section6"),
    twoSideBox2: makeNodeComponent("twoSideBox2"),
    subHeading4: makeNodeComponent("subHeading4"),
    peraContent2: makeNodeComponent("peraContent2"),
    unorderList2: makeNodeComponent("unorderList2"),
    listIteam2: makeNodeComponent("listIteam2"),
    listIteam9: makeNodeComponent("listIteam9"),
    listIteam10: makeNodeComponent("listIteam10"),
    listIteam11: makeNodeComponent("listIteam11"),
    listIteam12: makeNodeComponent("listIteam12"),
    listIteam13: makeNodeComponent("listIteam13"),
    bannerImage3: makeNodeComponent("bannerImage3"),
    imageMarketing3: makeNodeComponent("imageMarketing3"),
    section7: makeNodeComponent("section7"),
    subHeading5: makeNodeComponent("subHeading5"),
    line3: makeNodeComponent("line3"),
    blockChapterContent: makeNodeComponent("blockChapterContent"),
    blockChapterContent4: makeNodeComponent("blockChapterContent4"),
    blockChapterContent2: makeNodeComponent("blockChapterContent2"),
    blockChapterContent3: makeNodeComponent("blockChapterContent3"),
    section8: makeNodeComponent("section8"),
    avtarContent: makeNodeComponent("avtarContent"),
    avatarImage: makeNodeComponent("avatarImage"),
    section9: makeNodeComponent("section9"),
    svg: makeNodeComponent("svg"),
    section1: makeNodeComponent("section1"),
    container: makeNodeComponent("container"),
    useTicket: makeNodeComponent("useTicket"),
    flexBox: makeNodeComponent("flexBox"),
    bannerImage: makeNodeComponent("bannerImage"),
    contentBlock: makeNodeComponent("contentBlock"),
    mainHeading: makeNodeComponent("mainHeading"),
    peraBanner: makeNodeComponent("peraBanner"),
    footer: makeNodeComponent("footer"),
    footerLogo: makeNodeComponent("footerLogo"),
    logo2: makeNodeComponent("logo2"),
    footerLink: makeNodeComponent("footerLink"),
    footerLink4: makeNodeComponent("footerLink4"),
    footerLink5: makeNodeComponent("footerLink5"),
    copyRight: makeNodeComponent("copyRight"),
    socialIcons: makeNodeComponent("socialIcons"),
    twitter: makeNodeComponent("twitter"),
    facebook: makeNodeComponent("facebook"),
    youtube: makeNodeComponent("youtube"),
    vimeo: makeNodeComponent("vimeo"),

    // Metadata about props expected for PlasmicPlay
    internalVariantProps: PlasmicPlay__VariantProps,
    internalArgProps: PlasmicPlay__ArgProps
  }
);

export default PlasmicPlay;
/* prettier-ignore-end */
